export default {
  SET_SETTINGS (state, payload) {
    state.settings = payload;
  },
  SET_GLOBAL_TICKER (state, payload) {
    state.ticker = payload;
  },
};
